"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const juejuezi_1 = __importDefault(require("../lib/juejuezi"));
const registries_1 = require("../registries");
registries_1.functionRegistry.set('j', (context, args) => {
    return juejuezi_1.default(args[0], args[1]);
});
